import styled from 'styled-components';

import { FormGridRowBase } from '../../AnketaForm.styles';
import { AnketaInputMask, AnketaFormHeader } from '../../../MainAnketa.styles';

export const FormGridRow = styled(FormGridRowBase)`
  grid-template-areas:
    '. head head head head . . .'
    '. sdin sdin date date is . .';
`;

export const FormHeader = styled(AnketaFormHeader)`
  grid-area: head;
  grid-template-areas: '. . . . . . . .';
`;

export const SecondDocumentInput = styled(AnketaInputMask)`
  grid-area: sdin;
`;

export const DriverLicenseDate = styled(AnketaInputMask)`
  grid-area: date;
`;

export const PassportDate = styled(AnketaInputMask)`
  grid-area: date;
`;

export const AreaInfo = styled.div`
  svg {
    cursor: pointer;
  }
`;

export const DateAreaInfo = styled(AreaInfo)`
  grid-area: ${(p) => (p.showDate ? 'is' : 'date')};
  margin-top: 19px;
`;
